export default __webpack_public_path__ + "static/media/payments.2b7766a6.png";